import axios from 'axios';

export const getOffers = async (navigate) => {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/trader/offers`, {
            withCredentials: true,
            validateStatus: () => true
        });
        if (!result.data.success && (result.data.error.code === 'NO_TOKEN' || result.data.error.code === 'INVALID_TOKEN')) {
            localStorage.removeItem('user');
            navigate('/login');
        }
        return result.data;
    } catch (_) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
};

export const putOffers = async (offers) => {
    try {
        const res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/trader/offers`,
        {
            offers: offers.map(o => ({
            index: o.id,
            title: o.title,
            description: o.description,
            activated: o.active,
            })),
        }, { withCredentials: true });
    return res.data;

    } catch (error) {
        return null;
    }
};
